import { render } from "./AddAccountSideBar.vue?vue&type=template&id=99ecc340&scoped=true"
import script from "./AddAccountSideBar.vue?vue&type=script&lang=js"
export * from "./AddAccountSideBar.vue?vue&type=script&lang=js"

import "./AddAccountSideBar.vue?vue&type=style&index=0&id=99ecc340&scoped=true&lang=scss"
import "./AddAccountSideBar.vue?vue&type=style&index=1&id=99ecc340&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99ecc340"]])

export default __exports__